// noinspection JSUnusedLocalSymbols

import { AddressTypeEnum } from './enums/address-type.enum';
import { HandlingTypeEnum } from './enums/handling-type.enum';
import { UserTypeEnum } from './enums/user-type.enum';
import { TransportTypology } from './enums/transport-typology.enum';
import { TemperatureEnum } from './enums/temperature.enum';
import { AccessConstraintEnum } from './enums/access-constraint.enum';
import { LoadingConstraintEnum } from './enums/loading-constraint.enum';

export enum LibIconEnum {
  FAS = 'fas',
  BARY_ICONS = 'baryicons',
}

export class OptionsTypeSelector {
  // Type d'adresse
  private static readonly PICKUP = new OptionsTypeSelector(AddressTypeEnum.PICKUP, 'Expedition', 'truck-loading', LibIconEnum.FAS, AddressTypeEnum.PICKUP);
  private static readonly DELIVERY = new OptionsTypeSelector(AddressTypeEnum.DELIVERY, 'Livraison', 'shipping-fast', LibIconEnum.FAS, AddressTypeEnum.DELIVERY);
  private static readonly BOTH = new OptionsTypeSelector(AddressTypeEnum.BOTH, 'Les deux', 'ellipsis-h', LibIconEnum.FAS, AddressTypeEnum.BOTH);

  // Mode de chargement
  static readonly A_QUAI = new OptionsTypeSelector('A_QUAI', 'À quai', 'baryicon-quay-loading', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.DOCK);
  static readonly HAYON = new OptionsTypeSelector('HAYON', 'Hayon', 'baryicon-hatchback', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.HAYON);
  static readonly PAR_LE_COTE = new OptionsTypeSelector('PAR_LE_COTE', 'Par le côté', 'baryicon-side-load', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.SIDE);
  static readonly PAR_LE_TOIT = new OptionsTypeSelector('PAR_LE_TOIT', 'Par le toit', 'baryicon-top-load', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.TOP);
  static readonly CRANE = new OptionsTypeSelector('CRANE', 'Grue', 'baryicon-crane', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.CRANE);
  static readonly MOUNTED_FORKLIFT = new OptionsTypeSelector(
    'MOUNTED_FORKLIFT',
    'Chariot',
    'baryicon-mounted-forklift',
    LibIconEnum.BARY_ICONS,
    LoadingConstraintEnum.MOUTED_FORKLIFT
  );
  static readonly LOAD_RAMP = new OptionsTypeSelector('LOAD_RAMP', 'Rampe', 'baryicon-load-ramp', LibIconEnum.BARY_ICONS, LoadingConstraintEnum.RAMP);
  static readonly NO_LOADING_CONSTRAINT = new OptionsTypeSelector(
    'NO_LOADING_CONSTRAINT',
    'Sans contrainte',
    'baryicon-no-loading-constraint',
    LibIconEnum.BARY_ICONS,
    LoadingConstraintEnum.NONE
  );

  // Contraintes d'accès
  static readonly SANS_CONTRAINTES = new OptionsTypeSelector('SANS_CONTRAINTES', 'Sans contrainte', 'baryicon-truck-1', LibIconEnum.BARY_ICONS, AccessConstraintEnum.NONE);
  static readonly PORTEUR = new OptionsTypeSelector('PORTEUR', 'Porteur (19T)', 'baryicon-truck-2', LibIconEnum.BARY_ICONS, AccessConstraintEnum.TRUCK_19T);
  static readonly PETIT_PORTEUR = new OptionsTypeSelector('PETIT_PORTEUR', 'Petit porteur (7,5T)', 'baryicon-truck-3', LibIconEnum.BARY_ICONS, AccessConstraintEnum.TRUCK_7_5T);
  static readonly VEHICULE_LEGER = new OptionsTypeSelector('VEHICULE_LEGER', 'Véhicule léger (3,5T)', 'baryicon-truck-4', LibIconEnum.BARY_ICONS, AccessConstraintEnum.TRUCK_3_5T);

  // Unité de manutention
  static readonly PARCEL = new OptionsTypeSelector(HandlingTypeEnum.PARCEL, 'Colis', 'box', LibIconEnum.FAS, HandlingTypeEnum.PARCEL);
  static readonly PALLET = new OptionsTypeSelector(HandlingTypeEnum.PALLET, 'Palette', 'pallet', LibIconEnum.FAS, HandlingTypeEnum.PALLET);
  static readonly CRATE_OF_WINE = new OptionsTypeSelector(
    HandlingTypeEnum.CRATE_OF_WINE,
    'Bouteilles',
    'baryicon-crate_of_wine',
    LibIconEnum.BARY_ICONS,
    HandlingTypeEnum.CRATE_OF_WINE
  );
  static readonly CONTAINER = new OptionsTypeSelector(HandlingTypeEnum.CONTAINER, 'Conteneur', 'baryicon-surface-container', LibIconEnum.BARY_ICONS, HandlingTypeEnum.CONTAINER);
  static readonly ROLL = new OptionsTypeSelector(HandlingTypeEnum.ROLL, 'Roll', 'th-large', LibIconEnum.FAS, HandlingTypeEnum.ROLL);
  static readonly BUNDLE = new OptionsTypeSelector(HandlingTypeEnum.BUNDLE, 'Fardeau', 'xmarks-lines', LibIconEnum.FAS, HandlingTypeEnum.BUNDLE);
  static readonly INDIVISIBLE = new OptionsTypeSelector(HandlingTypeEnum.INDIVISIBLE, 'Indivisible', 'tractor', LibIconEnum.FAS, HandlingTypeEnum.INDIVISIBLE);
  static readonly PERSONALIZED = new OptionsTypeSelector(HandlingTypeEnum.PERSONALIZED, 'Personnalisé', 'expand-arrows-alt', LibIconEnum.FAS, HandlingTypeEnum.PERSONALIZED);

  // Type d'utilisateur :
  private static readonly USER_TYPE_COMPANY = new OptionsTypeSelector(UserTypeEnum.COMPANY, 'Une entreprise', 'building', LibIconEnum.FAS, UserTypeEnum.COMPANY);
  private static readonly USER_TYPE_ASSOCIATION = new OptionsTypeSelector(UserTypeEnum.ASSOCIATION, 'Une association', 'users', LibIconEnum.FAS, UserTypeEnum.ASSOCIATION);
  private static readonly USER_TYPE_USER = new OptionsTypeSelector(UserTypeEnum.INDIVIDUAL, 'Un particulier', 'user', LibIconEnum.FAS, UserTypeEnum.INDIVIDUAL);

  // Type de transport
  public static TYPE_MARCHANDISES_GENERALES = new OptionsTypeSelector(
    TransportTypology.GENERAL_GOODS,
    'LABEL.GENERAL_GOOD',
    'baryicon-pallet',
    LibIconEnum.BARY_ICONS,
    TransportTypology.GENERAL_GOODS,
    'selected'
  );
  public static TYPE_CONTROLLED_TEMPERATURE = new OptionsTypeSelector(
    TransportTypology.CONTROLLED_TEMPERATURE,
    'LABEL.CONTROLLED_TEMPERATURE',
    'baryicon-frozen',
    LibIconEnum.BARY_ICONS,
    TransportTypology.CONTROLLED_TEMPERATURE,
    'disabled'
  );
  public static TYPE_HAZARDOUS_MATERIAL = new OptionsTypeSelector(
    TransportTypology.HAZARDOUS_MATERIAL,
    'LABEL.ADR',
    'baryicon-adr',
    LibIconEnum.BARY_ICONS,
    TransportTypology.HAZARDOUS_MATERIAL,
    'disabled'
  );

  // Mode de chargement
  static readonly COOL = new OptionsTypeSelector(TemperatureEnum.COOL, 'Frais (température positive)', 'temperature-low', LibIconEnum.FAS, TemperatureEnum.COOL);
  static readonly FROZEN = new OptionsTypeSelector(TemperatureEnum.FROZEN, 'Surgelé (température négative)', 'snowflake', LibIconEnum.FAS, TemperatureEnum.FROZEN);

  public static readonly LOADING_CONSTRAINT = new Array<OptionsTypeSelector>(
    OptionsTypeSelector.NO_LOADING_CONSTRAINT,
    OptionsTypeSelector.A_QUAI,
    OptionsTypeSelector.HAYON,
    OptionsTypeSelector.PAR_LE_COTE,
    OptionsTypeSelector.PAR_LE_TOIT,
    OptionsTypeSelector.CRANE,
    OptionsTypeSelector.MOUNTED_FORKLIFT,
    OptionsTypeSelector.LOAD_RAMP
  );

  public static readonly ACCESS_CONSTRAINT = new Array<OptionsTypeSelector>(
    OptionsTypeSelector.SANS_CONTRAINTES,
    OptionsTypeSelector.PORTEUR,
    OptionsTypeSelector.PETIT_PORTEUR,
    OptionsTypeSelector.VEHICULE_LEGER
  );

  public static readonly TRANSPORT_HANDLING_TYPE = new Array<OptionsTypeSelector>(
    OptionsTypeSelector.PALLET,
    OptionsTypeSelector.PARCEL,
    OptionsTypeSelector.CRATE_OF_WINE,
    OptionsTypeSelector.CONTAINER,
    OptionsTypeSelector.ROLL,
    OptionsTypeSelector.BUNDLE,
    OptionsTypeSelector.INDIVISIBLE,
    OptionsTypeSelector.PERSONALIZED
  );

  public static readonly BARY_USER_TYPES = new Array<OptionsTypeSelector>(
    OptionsTypeSelector.USER_TYPE_COMPANY,
    OptionsTypeSelector.USER_TYPE_USER,
    OptionsTypeSelector.USER_TYPE_ASSOCIATION
  );

  public static readonly ADDRESS_TYPE = new Array<OptionsTypeSelector>(OptionsTypeSelector.PICKUP, OptionsTypeSelector.DELIVERY, OptionsTypeSelector.BOTH);

  public static readonly CONTROLLED_TEMPERATURE = new Array<OptionsTypeSelector>(OptionsTypeSelector.COOL, OptionsTypeSelector.FROZEN);

  // private to disallow creating other instances of this type
  public constructor(public id: string, public label: string, public icon: string, public libIcon: string, public value: any, public status: string = 'enabled') {}
}
